import instance from './AxiosService';

const GameService = {
  getAllGames: async () => {
    return await instance.get('/games/admin/all');
  },
  toggleGame: async (gameId, isEnabled) => {
    return await instance.patch(`/games/admin/${gameId}/toggle`, { isEnabled });
  },
  updateGame: async (gameId, data) => {
    return await instance.put(`/games/admin/${gameId}`, data);
  },
};

export default GameService;

